// @flow

// Round numbers to any number of decimal values.
// Defaults to two decimals.
export function round(value: number, decimals: number = 2) {
  return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
}

// Prepends the dollar sign and adds two decimal values if it's an integer.
// e.g.: parseCurrency(1500) returns $1500.00
export function parseCurrency(value: number): string {
  return `$${round(value).toFixed(2)}`;
}
